import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center space-x-2 mt-4 mb-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined icon-light" }, "person_add", -1)
const _hoisted_4 = { class: "flex items-center space-x-4" }
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center my-4 mx-2"
}
const _hoisted_9 = { class: "text-lg" }
const _hoisted_10 = { class: "text-sm text-muted" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col items-center my-4 mx-12"
}
const _hoisted_12 = { class: "flex items-center space-x-4 mr-8" }
const _hoisted_13 = { class: "mt-6" }
const _hoisted_14 = { class: "mb-1" }
const _hoisted_15 = { class: "flex lg:flex-row flex-col lg:space-y-0 space-y-4 lg:items-center card w-full" }
const _hoisted_16 = { class: "flex items-center space-x-3 lg:w-1/3" }
const _hoisted_17 = { class: "ml-2 mr-4 flex flex-col -space-y-1" }
const _hoisted_18 = { class: "flex items-center space-x-1" }
const _hoisted_19 = { class: "text-lg" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons ml-1 inline-icon text-muted" }, " shield ", -1)
const _hoisted_21 = {
  key: 0,
  class: "flex items-center space-x-1"
}
const _hoisted_22 = { class: "text-sm text-muted" }
const _hoisted_23 = ["href"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  style: {"font-size":"14px !important"},
  class: "material-icons-outlined icon-light"
}, " email ", -1)
const _hoisted_25 = { class: "flex flex-wrap w-full" }
const _hoisted_26 = { class: "text-darkText" }
const _hoisted_27 = {
  key: 0,
  style: {"font-size":"1.3rem"},
  class: "ml-1 mr-2 material-icons-outlined"
}
const _hoisted_28 = { class: "ml-1 mt-0.5 text-sm text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Combobox = _resolveComponent("Combobox")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Chipset = _resolveComponent("Chipset")!
  const _component_CheckboxGroup = _resolveComponent("CheckboxGroup")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.canManagePermissions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_Combobox, {
            class: "lg:w-3/5 w-full",
            items: _ctx.usersAsOptions,
            placeholder: '',
            loading: _ctx.loadingUsers,
            label: _ctx.$t('course_permissions.search_user'),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.onShowUserPermissionsDialog($event, null))),
            onCreateOption: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onShowUserPermissionsDialog(null, $event))),
            onUpdateSearchText: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onUserSearch($event))),
            hint: _ctx.$t('course_permissions.search_user_hint'),
            isCreatableFunction: _ctx.isValidEmailAddress,
            filterFunction: _ctx.filterUser
          }, {
            default: _withCtx(({ item, searchText }) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_Avatar, {
                  user: item.data
                }, null, 8, ["user"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.highlightMatchingText(searchText, item.data.full_name)
                  }, null, 8, _hoisted_6),
                  _createElementVNode("p", {
                    innerHTML: _ctx.highlightMatchingText(searchText, item.data.email),
                    class: "text-muted text-sm -mt-1"
                  }, null, 8, _hoisted_7)
                ])
              ])
            ]),
            noResults: _withCtx(() => [
              (!_ctx.loadingUsers)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("course_permissions.search_cant_find_user")), 1),
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("course_permissions.try_with_email_hint")), 1)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_Spinner)
                  ]))
            ]),
            createOption: _withCtx(({ searchText }) => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Avatar, {
                  user: { full_name: searchText }
                }, null, 8, ["user"]),
                _createElementVNode("p", null, _toDisplayString(searchText), 1)
              ])
            ]),
            _: 1
          }, 8, ["items", "loading", "label", "hint", "isCreatableFunction", "filterFunction"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.$t("course_permissions.users_with_privileges")), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.privilegedUsers, (user) => {
        return (_openBlock(), _createElementBlock("div", {
          key: user.id,
          class: "py-2 hover:bg-light hover:bg-opacity-60 transition-colors duration-100"
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_Avatar, {
                size: 'lg',
                user: user
              }, null, 8, ["user"]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("p", _hoisted_19, _toDisplayString(user.full_name), 1),
                  (_ctx.isCourseCreator(user))
                    ? (_openBlock(), _createBlock(_component_Tooltip, {
                        key: 0,
                        textValue: _ctx.$t('course_permissions.course_creator'),
                        placement: 'bottom',
                        noArrow: true
                      }, {
                        default: _withCtx(() => [
                          _hoisted_20
                        ]),
                        _: 1
                      }, 8, ["textValue"]))
                    : _createCommentVNode("", true)
                ]),
                (user.email !== user.full_name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(user.email), 1),
                      _createElementVNode("a", {
                        style: {"margin-bottom":"-4.85px"},
                        href: 'mailto:' + user.email
                      }, [
                        _createVNode(_component_Btn, {
                          size: 'xs',
                          variant: 'icon',
                          outline: true
                        }, {
                          default: _withCtx(() => [
                            _hoisted_24
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_23)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_Chipset, {
                showAddChip: _ctx.canManagePermissions,
                disabled: 
								!_ctx.canManagePermissions || _ctx.isCourseCreator(user) || user.id == _ctx.currentUserId
							,
                deletable: true,
                modelValue: [],
                options: _ctx.getUserPermissionsAsOptions(user),
                onDeleteChip: ($event: any) => (_ctx.onRemoveUserPrivilege(user, $event)),
                onAddChip: ($event: any) => (_ctx.onShowUserPermissionsDialog(user.id, null)),
                addChipTooltip: _ctx.$t('course_permissions.add_permissions_tooltip')
              }, null, 8, ["showAddChip", "disabled", "options", "onDeleteChip", "onAddChip", "addChipTooltip"])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showDialog,
      confirmOnly: true,
      onYes: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideDialog()))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("course_privileges_page.edit_permissions_title")) + " " + _toDisplayString(_ctx.editingUser?.full_name), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_CheckboxGroup, {
            options: _ctx.privilegesAsOptions,
            modelValue: _ctx.editingUserPrivileges,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingUserPrivileges) = $event)),
            labelClass: 'text-xl flex-grow',
            optionClass: 'my-4',
            useToggles: true
          }, {
            default: _withCtx(({ icons }) => [
              (icons?.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(icons[0]), 1))
                : _createCommentVNode("", true)
            ]),
            item: _withCtx(({ description }) => [
              _createElementVNode("p", _hoisted_28, _toDisplayString(description), 1)
            ]),
            _: 1
          }, 8, ["options", "modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["showDialog"])
  ]))
}